import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import IosSwitch from "../IOSSwitch";
import ApiService from "../../services/api-service";
import notifier from "../Notifier";
import { getErrorString } from "../../constants/function";

/**
 * Pro creators only: people must subscribe before they can DM you.
 * Renders nothing for anyone who is not Pro. The server has the final say on
 * whether it can be switched on (it also needs fan subscriptions on).
 */
export default function DmSubscribersOnly() {
  const theme = useTheme();
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    ApiService.DM_SETTINGS_GET()
      .then((res) => {
        if (!cancelled) setSettings(res?.result || null);
      })
      .catch((error) => console.error("[DmSubscribersOnly] load failed", error));
    return () => {
      cancelled = true;
    };
  }, []);

  const toggle = async (subscribersOnly) => {
    if (saving) return;
    const previous = settings;
    setSettings({ ...settings, subscribersOnly });
    setSaving(true);
    try {
      const res = await ApiService.DM_SETTINGS_PUT({ subscribersOnly });
      setSettings(res?.result || previous);
    } catch (error) {
      setSettings(previous);
      notifier.error(getErrorString(error));
    } finally {
      setSaving(false);
    }
  };

  if (!settings?.eligible) return null;

  const note =
    settings.subscribersOnly && !settings.subscriptionsEnabled
      ? "Paused while fan subscriptions are off. Anyone can message you until you turn them back on."
      : "People must subscribe to you before they can send you a message. Anyone you message first can reply.";

  return (
    <Box
      className="__profile_card"
      sx={{
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "var(--paper-color, #1E1E1E)",
        border: "1px solid var(--accent-color, #262626)",
      }}
    >
      <Stack direction="column" padding="6px" gap="4px">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ color: theme.palette.text.primary, fontSize: 17 }}>
            Only subscribers can message me
          </Typography>
          <IosSwitch checked={Boolean(settings.subscribersOnly)} handleChange={toggle} />
        </Stack>
        <Typography className="fs-14" sx={{ color: theme.palette.text.secondary }}>
          {note}
        </Typography>
      </Stack>
    </Box>
  );
}
